"use strict";

exports.__esModule = true;
exports.default = void 0;
var _preact = require("preact");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable react/destructuring-assignment */

function EditorPanel(props) {
  var file = props.files[props.fileCardFor];
  var handleCancel = function handleCancel() {
    props.uppy.emit('file-editor:cancel', file);
    props.closeFileEditor();
  };
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('uppy-DashboardContent-panel', props.className),
    role: "tabpanel",
    "data-uppy-panelType": "FileEditor",
    id: "uppy-DashboardContent-panel--editor"
  }, (0, _preact.h)("div", {
    className: "uppy-DashboardContent-bar"
  }, (0, _preact.h)("div", {
    className: "uppy-DashboardContent-title",
    role: "heading",
    "aria-level": "1"
  }, props.i18nArray('editing', {
    file: (0, _preact.h)("span", {
      className: "uppy-DashboardContent-titleFile"
    }, file.meta ? file.meta.name : file.name)
  })), (0, _preact.h)("button", {
    className: "uppy-DashboardContent-back",
    type: "button",
    onClick: handleCancel
  }, props.i18n('cancel')), (0, _preact.h)("button", {
    className: "uppy-DashboardContent-save",
    type: "button",
    onClick: props.saveFileEditor
  }, props.i18n('save'))), (0, _preact.h)("div", {
    className: "uppy-DashboardContent-panelBody"
  }, props.editors.map(function (target) {
    return props.uppy.getPlugin(target.id).render(props.state);
  })));
}
var _default = exports.default = EditorPanel;